import { useStyles } from '../../hooks/useStyles';

function TableEmptyActionCell() {
  const { css, theme } = useStyles();

  return <span className={css({ height: theme.sizing.scale850 })} />;
}

export default TableEmptyActionCell;
